import React from 'react'
import './Footer.scss'
import '../../../scss/style.scss'
import {graphql, useStaticQuery} from 'gatsby'
import * as routes from '../../../constants/routes'
import * as paths from '../../../constants/paths'
import ExternalLink from '../../Links/ExternalLink'
import PhoneLink from '../../Links/PhoneLink'
import EmailLink from '../../Links/EmailLink'
import {useTranslation} from 'react-i18next'
import {Link} from 'gatsby-plugin-react-i18next'
import isPolishVersion from '../../../helpers/isPolishVersion'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPhone} from '@fortawesome/free-solid-svg-icons/faPhone'
import {faEnvelope} from '@fortawesome/free-solid-svg-icons/faEnvelope'
import {faYoutube} from '@fortawesome/free-brands-svg-icons/faYoutube'
import {faLinkedin} from '@fortawesome/free-brands-svg-icons/faLinkedin'
import {faFacebookF} from '@fortawesome/free-brands-svg-icons/faFacebookF'

const Footer = () => {
    const {t, i18n} = useTranslation()
    const data = useStaticQuery(
        graphql`
            query {
                allStrapiThulium {
                    edges {
                        node {
                            locale
                            name
                            phone_numbers {
                                phone
                                primary
                            }
                            email
                        }
                    }
                }
            }
        `
    )

    const thulium = data.allStrapiThulium.edges.find(({node}) => node.locale === i18n.language).node

    const primaryNumber =
        thulium.phone_numbers.find((phoneNumber) => phoneNumber.primary === true) || thulium.phone_numbers[0]

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__links">
                    <div className="footer__links-section">
                        <div className="footer__links__column ">
                            <p className="is-size-4">{t('footer_products')}</p>
                            <Link to={routes.PRODUCTS}>{t('footer_product')}</Link>
                            <Link to={routes.PRICING}>{t('footer_pricing')}</Link>
                            <Link to={routes.INDUSTRIES}>{t('footer_industries')}</Link>
                            <Link to={routes.CASESTUDIES}>{t('footer_casestudies')}</Link>
                        </div>
                        <div className="footer__links__column ">
                            <p className="is-size-4">{t('footer_title_company')}</p>
                            {isPolishVersion(i18n.language) && <Link to={routes.CAREERS}>{t('footer_careers')}</Link>}
                            <Link to={routes.PRESS_CENTRE}>{t('footer_press-centre')}</Link>
                            <Link to={routes.CONTACT}>{t('footer_contact')}</Link>
                        </div>
                    </div>
                    <div className="footer__links-section">
                        <div className="footer__links__column">
                            <p className="is-size-4">{t('footer_title_knowledge')}</p>
                            <Link to={routes.BLOG}>{t('footer_blog')}</Link>
                            <Link to={routes.DOCUMENTATION}>{t('footer_support')}</Link>
                            {isPolishVersion(i18n.language) && <Link to={routes.EBOOKS}>{t('footer_ebooks')}</Link>}
                            <Link to={routes.API}>{t('footer_api')}</Link>
                        </div>
                        <div className="footer__links__column">
                            <p className="is-size-4">{t('footer_title_others')}</p>
                            <Link to={routes.TERMS}>{t('footer_terms')}</Link>
                            {isPolishVersion(i18n.language) && <Link to={routes.PARTNERS}>{t('footer_partners')}</Link>}
                            {isPolishVersion(i18n.language) && <Link to={routes.DSA_FORM}>{t('footer_dsa')}</Link>}
                            <Link to={routes.ISO}>{t('footer_iso')}</Link>
                        </div>
                    </div>
                </div>
                <div className="footer__contact">
                    <p className="is-size-4" style={{marginLeft: '1.25rem'}}>
                        {t('footer_contact')}
                    </p>
                    <div
                        className="buttons is-centered"
                        style={{
                            marginTop: '0.75rem',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <PhoneLink
                            phone={primaryNumber.phone}
                            className="button is-rounded is-dark is-fullwidth is-justify-content-left"
                        >
                            <FontAwesomeIcon icon={faPhone} style={{marginRight: '0.75rem'}} />
                            {t('footer_contact_phone')}
                            {primaryNumber.phone}
                        </PhoneLink>
                        <EmailLink
                            email={thulium.email}
                            className="button is-rounded is-dark is-fullwidth is-justify-content-left"
                        >
                            <FontAwesomeIcon icon={faEnvelope} style={{marginRight: '0.75rem'}} />
                            {t('footer_contact_email')}
                            {thulium.email}
                        </EmailLink>
                        {isPolishVersion(i18n.language) && (
                            <div className="footer__social">
                                <div className="buttons">
                                    <ExternalLink className={'button is-circle'} href={paths.YOUTUBE} label={'Youtube'}>
                                        <FontAwesomeIcon icon={faYoutube} />
                                    </ExternalLink>
                                    <ExternalLink
                                        className={'button is-circle'}
                                        href={paths.LINKEDIN}
                                        label={'Linked In'}
                                    >
                                        <FontAwesomeIcon icon={faLinkedin} />
                                    </ExternalLink>
                                    <ExternalLink
                                        className={'button is-circle'}
                                        href={paths.FACEBOOK}
                                        label={'Facebook'}
                                    >
                                        <FontAwesomeIcon icon={faFacebookF} />
                                    </ExternalLink>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
